import React, { Component, Fragment } from 'react';
import SummaryFlightsContainer from './components/SummaryFlightsContainer';
import PaymentMethods from './components/PaymentMethods';
import StepHeader from '../../common/StepHeader';
import resizer from 'components/common/Resizer';
import Cards from '../../common/cards/Cards';
import { CARD_METHOD, DRIVER_METHOD } from 'components/components/booking/Summary/utils/PaymentMethodsConstants';
import FlipMove from 'react-flip-move';
import { connect } from 'react-redux';
import PrepareBookParams from './utils/PrepareBookParams';
import withRouter from 'components/components/common/withRouter';
import axios from 'components/AppRequest';
import BookingRedirect from '../utils/BookingRedirect';
import {
  resetBooking, setBookingCardId, showSidebar, setUserNameOverride,
  setUserPhoneOverride
} from 'components/actions/bookingActions'
import { updateLoggedCustomerInvoiceData } from 'components/actions/authActions'
import mergeErrors from 'components/helpers/mergeErrors';
import LoadingSpinner from '../../common/LoadingSpinner';
import {
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import { ENABLE_TRACKING, STRIPE_PK } from 'components/windowEnvs';
import { isEmpty } from 'lodash';

class Summary extends Component {

  constructor(props) {
    super(props);
    this.cardElementObject = null;
  }

  state = {
    paymentMethod: null,
    saveCard: true,
    paymentDescription: null,
    cardErrors: null,
    isLoading: false,
    csk: null,
    paymentIntentId: null,
  }

  trackPurchase = (reservation) => {
    if (ENABLE_TRACKING) {
      const { isLogged } = this.props;
      var price = reservation.amount_reservation;
      var id = reservation.id;
      var quantity = 1;
      var tax = 0;
      var itemName = reservation.payment_to_driver ? "PaymentDriver" : "PaymentOnline";

      if (reservation.are_both_reservations) {
        quantity = 2;
      }

      // ga('require', 'ecommerce');
      // ga('ecommerce:addTransaction', {
      //   'id': reservation.id,
      //   'affiliation': reservation.payment_to_driver ? "PKS RESERVATION NOT PAID" : "PKS RESERVATION PAID",
      //   'revenue': reservation.amount_reservation,
      //   'currency': 'NOK'
      // });
      // ga('ecommerce:send');
      // console.log("ecommerce:addTransaction");

      // fbq('track', 'Purchase', {
      //   value: reservation.amount_reservation,
      //   currency: 'NOK',
      //   content_type: isLogged ? 'logged' : 'not-logged',
      //   content_category: reservation.payment_to_driver ? 'driver-payment' : 'online-payment'
      // });

      var gtagHash = {
        transaction_id: `T_${id}`,
        value: price,
        // tax: 4.90,
        // shipping: 5.99,
        currency: "NOK",
        // coupon: "SUMMER_SALE",
        items: [
          // If someone purchases more than one item,
          // you can add those items to the items array
          {
            item_id: `R_${id}`,
            item_name: itemName,
            // affiliation: "Google Merchandise Store",
            // coupon: "SUMMER_FUN",
            // discount: 2.22,
            // index: 0,
            // item_brand: "Google",
            // item_category: "Apparel",
            // item_category2: "Adult",
            // item_category3: "Shirts",
            // item_category4: "Crew",
            // item_category5: "Short sleeve",
            // item_list_id: "related_products",
            // item_list_name: "Related Products",
            // item_variant: "green",
            // location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
            price: price,
            quantity: quantity
          }]
      };
      gtag("event", "purchase", gtagHash);

      fbq('track', 'Purchase', {
        value: reservation.amount_reservation,
        currency: 'NOK',
        content_type: isLogged ? 'logged' : 'not-logged',
        content_category: reservation.payment_to_driver ? 'driver-payment' : 'online-payment'
      });
    }
  }

  trans = (key, prefix = "content.bookingStep4") => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.bookingStep4');
  }

  componentDidMount() {
    new BookingRedirect(this.props).canViewSummary();
    this.stripe = Stripe(STRIPE_PK);
    this.props.showSidebar(true);
    this.setupOverrideUserData();
  }

  setupOverrideUserData() {
    var { isLogged, loggedCustomer, userData } = this.props;
    var name = '';
    var phone = '';
    if (isLogged && loggedCustomer) {
      name = loggedCustomer.name;
      phone = loggedCustomer.phone;
    } else {
      name = userData.name;
      phone = userData.phoneCountry.label + userData.phone;
    }
    if (isEmpty(this.props.userNameOverride)) {
      this.props.setUserNameOverride(name);
    }
    if (isEmpty(this.props.userPhoneOverride)) {
      this.props.setUserPhoneOverride(phone);
    }

  }

  resetCardElement = () => {
    this.cardElementObject = null;
  }

  onChangeSaveCard = () => {
    this.setState({ saveCard: !this.state.saveCard })
  }

  createPaymentIntent = (selectedCardId = null) => {
    this.setState({ isLoading: true, cardErrors: null });
    var prepareBookObj = new PrepareBookParams(this.props);
    prepareBookObj.setPaymentIntentId(this.state.paymentIntentId);
    prepareBookObj.setSelectedCardId(selectedCardId);
    var params = prepareBookObj.paramsWithPayment();
    this.mountStripe(selectedCardId);
    axios.post('/pwa/reservation/create-payment-intent', params)
      .then(response => {

        this.setState({
          csk: response.data.csk,
          paymentIntentId: response.data.id,
          isLoading: false,
          paymentDescription: response.data.description,
        });
      })
      .catch(err => {
        this.setState({ isLoading: false });
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(err.response.data.errors)
        });
        console.error(err)
      });
  }

  mountStripe = (selectedCardId) => {
    var stripeContainer = document.getElementById("stripe-container");
    if (selectedCardId === null) {
      stripeContainer.style.display = "block";
      var stripeStyles = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };
      if (this.cardElementObject === null) {
        var elements = this.stripe.elements();
        var cardElement = elements.create(
          'card',
          {
            hidePostalCode: true,
            style: stripeStyles
          },
        );
        cardElement.mount('#card-element');
        this.cardElementObject = cardElement;
      } else {
        this.cardElementObject.mount('#card-element');
      }
    } else {
      stripeContainer.style.display = "none";
      if (this.cardElementObject) {
        this.cardElementObject.unmount();
      }
    }
  }

  createDriverPaymentResevation = () => {
    var prepareBookObj = new PrepareBookParams(this.props);
    var params = prepareBookObj.params();
    axios.post('/pwa/reservation/create-driver-reservation-online', params)
      .then(response => {
        //CREATED RESERVATION WITH DRIVER PAYMENT
        this.trackPurchase(response.data);
        this.props.resetBooking();
        TransHelper.redirect(this.props, 'routes.url.confirmed');
      })
      .catch(err => {
        console.log('err', err);
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(err.response.data.errors)
        });
        this.setState({ isLoading: false });
      });
  }

  createOnlinePaymentReservation = () => {
    var prepareBookObj = new PrepareBookParams(this.props);
    var params = prepareBookObj.params();
    axios.post('/pwa/reservation/is-valid-reservation-online', params)
      .then(response => {
        this.stripeConfirmPaymentRequest();
      })
      .catch(err => {
        console.error(err);
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(err.response.data.errors)
        });
        this.setState({ isLoading: false });
      });
  }

  stripeConfirmPaymentRequest = () => {
    var customerName = "";
    if (this.props.isLogged) {
      customerName = this.props.loggedCustomer.name;
    } else {
      customerName = this.props.userData.name;
    }

    if (this.props.selectedCardId) {
      var stripePromise = this.stripe.handleCardPayment(
        this.state.csk, {
        payment_method: this.props.selectedCardId,
      }
      );
    } else {
      var stripePromise = this.stripe.handleCardPayment(
        this.state.csk, this.cardElementObject, {
        payment_method_data: {
          billing_details: { name: customerName },
        }
      }
      );
    }

    stripePromise.then((paymentResult) => {
      if (paymentResult.error) {
        this.setState({ cardErrors: paymentResult.error.message });
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(paymentResult.error.message)
        });
        this.setState({ isLoading: false });
      } else if (paymentResult.paymentIntent && paymentResult.paymentIntent.id) {
        this.reservationOnlineSaveAfterSuccessPayment(paymentResult);
      } else {
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: this.trans('errors.payment.paymentFailed'),
        });
      }
    });
  }

  reservationOnlineSaveAfterSuccessPayment = (paymentResult) => {
    // prepareBookObj.setCardData(this.state.card);
    var prepareBookObj = new PrepareBookParams(this.props);
    prepareBookObj.setSaveCard(this.state.saveCard);
    prepareBookObj.setSelectedCardId(this.props.selectedCardId);
    prepareBookObj.setSendInvoiceData(this.props.sendInvoice);
    prepareBookObj.setPaymentId(paymentResult.paymentIntent.id);
    prepareBookObj.setPaymentDescription(this.state.paymentDescription);
    prepareBookObj.setPaymentMethodId(paymentResult.paymentIntent.payment_method);
    var paramsPayment = prepareBookObj.paramsWithPayment();
    axios.post('/pwa/reservation/create-payment-reservation-online', paramsPayment)
      .then(response => {
        //CREATED RESERVATION WITH DRIVER PAYMENT
        this.trackPurchase(response.data);
        this.props.resetBooking();
        TransHelper.redirect(this.props, 'routes.url.confirmed');
      })
      .catch(err => {
        console.log('err', err);
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(err.response.data.errors)
        });
        this.setState({ isLoading: false });
      });
  }

  bookAction = (event) => {
    event.preventDefault();
    const { paymentMethod } = this.state;

    //reset error
    this.setState({
      isLoading: true,
      cardErrors: null
    }, () => {
      if (paymentMethod) {
        var prepareBookObj = new PrepareBookParams(this.props)
        if (!prepareBookObj.canDoRequest()) {
          this.props.createErrorNotification({
            title: this.transNotify('error'),
            message: this.trans('errors.payment.emptyData'),
          });
          this.setState({ isLoading: false });
          return;
        }

        if (paymentMethod === DRIVER_METHOD) {
          // ********** driver method **********
          this.createDriverPaymentResevation();
        } else {
          this.createOnlinePaymentReservation();
        }
      } else {
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: this.trans('errors.payment.selectPaymentMethod'),
        });
        this.setState({ isLoading: false });
      }
    });
  }

  handleSelectCard = (cardId) => {
    this.props.setBookingCardId(cardId);
    if (cardId !== null) {
      this.createPaymentIntent(cardId);
    }
  }

  changePaymentMethod = (method) => {
    this.setState({ paymentMethod: method });
  }

  backRedirect = () => {
    return this.props.isLogged ? 'routes.url.map' : 'routes.url.userData'
  }

  setStep = () => {
    const { childrenNumber, isLogged } = this.props;
    if (childrenNumber === 0 && isLogged) {
      return 3;
    } else if (childrenNumber > 0 && isLogged || childrenNumber === 0 && !isLogged) {
      return 4;
    } else if (childrenNumber > 0 && !isLogged) {
      return 5;
    }
  }

  render() {
    const isMobile = this.props.windowWidth <= 960;
    const { isLoading } = this.state;
    var totalPrice = this.props.departurePrice + this.props.returnPrice;
    return (
      <div className="content" style={{ padding: 0 }}>

        <div className="grid-layout grid-layout--vh">
          <div className="grid-layout__item grid-layout__item--desc grid-layout__item--middle">
            <div className={"content__desc content__desc--static" + (!isMobile ? ' content__desc--wider' : '')} >
              <StepHeader
                link={this.backRedirect()}
                linkTitle={this.props.isLogged ? this.trans('stepHeader.linkTitleAddressSelection') : this.trans('stepHeader.linkTitleUserSelection')}
                step={this.setStep()}
                booking
                title={this.trans('stepHeader.title')}
                margin={30}
              />

              <form>
                <fieldset>
                  <legend className="visuallyhidden">{this.trans('summary.title')}</legend>
                  <SummaryFlightsContainer locale={this.props.locale} />
                  <p className="text-color text-bold text-center">
                    {this.trans('summary.totalPrice')} : {totalPrice} <span className="currency">{this.trans('currency', 'content.common')}</span>
                  </p>
                  <PaymentMethods
                    paymentMethod={this.state.paymentMethod}
                    changePaymentMethod={this.changePaymentMethod}
                    showCards={isMobile}
                    createPaymentIntent={this.createPaymentIntent}
                    cardErrors={this.state.cardErrors}
                    saveCard={this.state.saveCard}
                    onChangeSaveCard={this.onChangeSaveCard}
                    selectedCardId={this.props.selectedCardId}
                    setCardId={this.handleSelectCard}
                    resetCardElement={this.resetCardElement}
                  />

                  {/* <p className="text-center text-italic" style={{ margin: '-25px auto 25px', maxWidth: '250px', fontSize: '14px' }}>
                    <span>We will send you a SMS with the time</span> of pick up one day before departure
                  </p> */}

                  {isLoading ?
                    <LoadingSpinner className="button button--expand" />
                    :
                    <button
                      className="button button--expand"
                      onClick={this.bookAction}
                    >
                      {this.trans('summary.bookNow')}
                    </button>
                  }
                </fieldset>
              </form>

            </div>
          </div>

          <div className="grid-layout__item grid-layout__item--info">
            <FlipMove
              className="grid-layout__container-flip-wrap"
              duration={150}
              easing="ease-out"
              enterAnimation="accordionHorizontal"
              leaveAnimation="accordionHorizontal">
              {this.state.paymentMethod === CARD_METHOD && isMobile == false &&
                <div className="grid-layout__container-flip">
                  <div className="content__desc">
                    <Cards
                      cardErrors={this.state.cardErrors}
                      createPaymentIntent={this.createPaymentIntent}
                      saveCard={this.state.saveCard}
                      onChangeSaveCard={this.onChangeSaveCard}
                      selectedCardId={this.props.selectedCardId}
                      setCardId={this.handleSelectCard}
                      locale={this.props.locale}
                      resetCardElement={this.resetCardElement}
                    />
                  </div>
                </div>
              }
            </FlipMove>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    airportFrom: state.booking.airportFrom,
    airportTo: state.booking.airportTo,
    adultsNumber: state.booking.adultsNumber,
    childrenNumber: state.booking.childrenNumber,
    studentsNumber: state.booking.studentsNumber,
    departureFlight: state.booking.departureFlight,
    returnFlight: state.booking.returnFlight,
    returnAddress: state.booking.returnAddress,
    departureAddress: state.booking.departureAddress,
    differentReturnAddress: state.booking.differentReturnAddress,
    departurePrice: state.booking.departurePrice,
    returnPrice: state.booking.returnPrice,
    userData: state.booking.userData,
    kidsSafety: state.booking.kidsSafety,
    isLogged: state.app.isLogged,
    loggedCustomer: state.app.customer,
    selectedCardId: state.booking.selectedCardId,
    invoiceData: state.booking.invoiceData,
    sendInvoice: state.booking.sendInvoice,
    userNameOverride: state.booking.userNameOverride,
    userPhoneOverride: state.booking.userPhoneOverride
  };
};

export default withRouter(
  resizer(
    connect(
      mapStateToProps,
      {
        resetBooking, updateLoggedCustomerInvoiceData,
        setBookingCardId, createErrorNotification, showSidebar,
        setUserNameOverride,
        setUserPhoneOverride
      }
    )(Summary)
  )
);
